import { AuthService } from "./../../../../core/services/auth.service";
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from "rxjs/operators";
import { EventService } from "src/app/core/services/event.service";
import { PropertyDataService } from "src/app/core/services/property-data.service";
import { environment } from "src/environments/environment";
import { PropertiesService } from "../../services/properties.services";
import { PermissionsService } from "src/app/core/services/permissions.service";

@Component({
  selector: "app-agents",
  templateUrl: "./agents.component.html",
  styleUrls: ["./agents.component.scss"],
})
export class AgentsComponent implements OnInit, OnDestroy {
  @Input() dataToFormInitAgents: any;
  @Input() dataAgents: any;
  @Input() businessStatus: any;
  @Input() saleId: any;
  @Input() propertyAgentsData: any;
  @Input() dataToFormInitDetails: any;
  @Input() isUpdate: boolean = false;
  submitted = false;
  agents: {
    id?: string;
    name?: string;
    agentFile?: string;
    add?: boolean;
    store?: string;
    role?: any;
    roleName?: string;
  }[] = [];
  agentsAvailableForProperty: any[] = [];
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  subscriptionSubmitted!: Subscription;
  queryField = new FormControl();
  filter: string = "";
  @Input()
  detailsForm: any;
  store: any;
  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any[];
    associatedUsers?: any;
  };
  @Input()
  property: any;
  openInput = null;
  bkpValue: any;
  closeModal = false;
  loading$!: BehaviorSubject<boolean>;
  constructor(
    private modalService: NgbModal,
    private eventService: EventService,
    private propertiesService: PropertiesService,
    private propertyDataService: PropertyDataService,
    public authService: AuthService,
    public permissionsService: PermissionsService,
    private renderer: Renderer2
  ) {
    this.loading$ = new BehaviorSubject<boolean>(false);
  }

  ngOnInit(): void {
    const { id, role, stores, associatedUsers } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };
    this.agents = this.dataToFormInitAgents;
    this.refreshAgentsAvailableForProperty();
    this.propertyDataService.updateAgentList(this.agents);
    if (!this.subscriptionSubmitted)
      this.subscriptionSubmitted = this.eventService.subscribe(
        "get-data-tab-agents",
        () => {
          this.eventService.broadcast(
            "data-tab-agents",
            this.propertyAgentsData
          );
        }
      );
    this.searchData();
    this.store = this.detailsForm.data.store;
    this.propertyDataService.currentAgentList.subscribe((data) => {
      this.agents = data;
      this.refreshAgentsAvailableForProperty();
    });

    this.completeCMI();
  }

  completeCMI() {
    if (this.propertyAgentsData) {
      const mainAgentData = this.propertyAgentsData.find((a: any) => a?.isMain );

      // 🔹 Caso o mainAgent venha apenas com ID, tenta encontrar o objeto completo
      const mainAgent =
        mainAgentData && typeof mainAgentData === "object"
          ? {
              id: mainAgentData.id,
              name: mainAgentData.user?.name ?? mainAgentData.name ?? "",
              email: mainAgentData.user?.email ?? mainAgentData.email ?? "",
              fiscalIdentification:
                mainAgentData.userAddress?.fiscalIdentification ?? "",
            }
          : null;

      // 🔹 Atualiza no PropertyDataService com formato padronizado
      this.propertyDataService.updateTab("agents", {
        mainAgent,
      });
    }
  }

  openInpt(value: any, agentId: any) {
    if (!this.openInput) {
      this.openInput = agentId;
      this.bkpValue = value;
    }
  }

  childrenClick(event: MouseEvent) {
    event.stopPropagation();
  }

  /**
   * on settings button clicked from topbar
   */
  onTeamButtonClicked() {
    document.body.classList.toggle("right-bar-enabled");
    const overlay = document.querySelector(".team-overlay");
    if (overlay != null) {
      overlay.classList.add("show");
    }
    const rightBar = document.getElementById("offcanvasExample");
    if (rightBar != null) {
      rightBar.classList.toggle("show");
      rightBar.setAttribute("style", "visibility: visible;");
    }
  }

  /**
   * Open modal
   * @param content modal content
   */
  openModal(content: any) {
    this.submitted = false;
    this.closeModal = false;

    this.agents.forEach((ag1: any) => {
      let agent: any = this.propertyAgentsData?.find((ag2: any) => {
        return ag2.id == ag1.id;
      });
      if (agent?.add) ag1.add = agent.add;
    });

    let modal: NgbModalRef = this.modalService.open(content, {
      size: "md",
      centered: true,
      backdropClass: "custom-modal",
    });

    modal.dismissed.subscribe(() => {
      this.closeModal = true;
      if (this.loading$.getValue() === false) {
        setTimeout(() => {
          const propertyLoader = document.querySelector(".propertyLoader2");
          this.renderer.addClass(propertyLoader, "d-none");
        }, 500);
      } else {
        this.loading$.asObservable().subscribe((data) => {
          if (this.closeModal && data === false) {
            setTimeout(() => {
              const propertyLoader = document.querySelector(".propertyLoader2");
              this.renderer.addClass(propertyLoader, "d-none");
            }, 500);
          }
        });
      }
    });

    modal.closed.subscribe(() => {
      this.closeModal = true;
      if (this.loading$.getValue() === false) {
        setTimeout(() => {
          const propertyLoader = document.querySelector(".propertyLoader2");
          this.renderer.addClass(propertyLoader, "d-none");
        }, 500);
      } else {
        this.loading$.asObservable().subscribe((data) => {
          if (this.closeModal && data === false) {
            setTimeout(() => {
              const propertyLoader = document.querySelector(".propertyLoader2");
              this.renderer.addClass(propertyLoader, "d-none");
            }, 500);
          }
        });
      }
    });
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    const overlay = document.querySelector(".team-overlay");
    if (overlay != null) {
      overlay.classList.remove("show");
    }
    const rightBar = document.getElementById("offcanvasExample");
    if (rightBar != null) {
      rightBar.classList.remove("show");
    }
  }

  searchData() {
    if (this.agents?.length > 0)
      this.queryField.valueChanges
        .pipe(
          map((value) => value.trim()),
          debounceTime(200),
          distinctUntilChanged(),
          switchMap((value) =>
            this.propertiesService.getDataForAgents(this.store, value)
          )
        )
        .subscribe((agents) => {
          this.agents = agents;
          this.refreshAgentsAvailableForProperty();
          this.agents.forEach((ag1: any) => {
            let agent: any = this.propertyAgentsData.find((ag2: any) => {
              return ag2.id == ag1.id;
            });
            if (agent?.add) ag1.add = agent.add;
          });
        });
  }

  changeMainAgent(data: any) {
    this.propertyAgentsData = this.propertyAgentsData.map((agent: any) => {
      return { ...agent, isMain: false };
    });

    let agent: any = this.propertyAgentsData?.find((d: any) => d.id == data.id);
    agent.isMain = true;

    const storeId = this.detailsForm?.data?.store;
    const propertyTypeId = this.detailsForm?.data?.propertyType;
    const agentId = agent?.id;

    if (this.dataToFormInitDetails.checkAutoRef && !this.isUpdate && !this.detailsForm?.data?.isTempReference) {
      if (storeId && agentId) {
        this.propertiesService
          .previewReference(false, storeId, agentId, propertyTypeId)
          .subscribe({
            next: (res) => {
              this.detailsForm.data.reference = res.reference;
            },
            error: () => {
              this.detailsForm.data.reference = "";
            },
          });
      }
    }

    this.completeCMI();
  }

  changeListingAgent(data: any) {
    if (this.isStoreOperatorAgent(data)) {
      return;
    }

    // this.propertyAgentsData = this.propertyAgentsData.map((ag: any) => {
    //   return { ...ag, isListingAgent: false };
    // });
    let ag: any = this.propertyAgentsData.find((d: any) => {
      return d.id == data.id;
    });
    ag.isListingAgent = true;

    this.completeCMI();
  }

  removeListingAgent(data: any) {
    this.propertyAgentsData = this.propertyAgentsData.map((ag: any) => {
      return { ...ag, isListingAgent: false };
    });

    this.completeCMI();
  }

  addAgentToProperty(data: any) {
    if (this.isStoreOperatorAgent(data)) {
      return;
    }

    if (!this.propertyAgentsData || this.propertyAgentsData.length === 0) {
      data.isMain = true;
      data.isListingAgent = true;
    }

    this.propertyAgentsData.push(data);
    data.add = true;

    if (data.isMain) {
      const storeId = this.detailsForm?.data?.store;
      const propertyTypeId = this.detailsForm?.data?.propertyType;
      const agentId = data?.id;

      if (this.dataToFormInitDetails.checkAutoRef && !this.isUpdate && !this.detailsForm?.data?.isTempReference) {
        this.propertiesService
          .previewReference(false, storeId, agentId, propertyTypeId)
          .subscribe({
            next: (res) => {
              this.detailsForm.data.reference = res.reference;
            },
            error: () => {
              this.detailsForm.data.reference = "";
            },
          });
      }
    }

    this.completeCMI();
  }

  deleteAgentToProperty(data: any) {
    // remove o agente da lista
    this.propertyAgentsData = this.propertyAgentsData?.filter(
      (ag: any) => ag.id != data.id
    );

    // garante sempre um main e um listingAgent se ainda existirem agentes
    if (data.isMain && this.propertyAgentsData.length > 0) {
      this.propertyAgentsData[0].isMain = true;
    }
    if (data.isListingAgent && this.propertyAgentsData.length > 0) {
      const nextListingAgent = this.propertyAgentsData.find(
        (agent: any) => !this.isStoreOperatorAgent(agent)
      );
      if (nextListingAgent) {
        nextListingAgent.isListingAgent = true;
      }
    }

    // só recalcula reference se o removido era main
    if (data.isMain) {
      // remove flags do agente na lista "disponíveis"
      let agent: any = this.agents.find((d: any) => d.id == data.id);
      if (agent) {
        agent.add = false;
        agent.isMain = false;
        agent.isListingAgent = false;
      }

      const newMain = this.propertyAgentsData.find(
        (d: any) => d.isMain === true
      );

      const storeId = this.detailsForm?.data?.store;
      const propertyTypeId = this.detailsForm?.data?.propertyType;
      const agentId = newMain?.id;

      if (this.dataToFormInitDetails.checkAutoRef && !this.isUpdate && !this.detailsForm?.data?.isTempReference) {
        this.propertiesService
          .previewReference(false, storeId, agentId, propertyTypeId)
          .subscribe({
            next: (res) => {
              this.detailsForm.data.reference = res.reference;
            },
            error: () => {
              this.detailsForm.data.reference = "";
            },
          });
      }
    } else {
      // remove flags do agente na lista "disponíveis"
      let agent: any = this.agents.find((d: any) => d.id == data.id);
      if (agent) {
        agent.add = false;
        agent.isMain = false;
        agent.isListingAgent = false;
      }
    }

    this.completeCMI();
  }

  closeAddAgentToProperty() {
    this.modalService.dismissAll();
  }

  refreshAgentsAvailableForProperty() {
    this.agentsAvailableForProperty =
      this.agents?.filter((agent: any) => !this.isStoreOperatorAgent(agent)) ??
      [];
  }

  // Delegado ao PermissionsService: um STORE OPERATOR deixa de ser excluído
  // quando a entidade liga "diretores de loja também atuam como consultores".
  isStoreOperatorAgent(agent: any): boolean {
    return !this.permissionsService.canBeListingAgent(agent);
  }

  ngOnDestroy(): void {
    this.eventService.broadcast("data-tab-agents", this.propertyAgentsData);
    this.propertyDataService.updateAgentList([]);
    this.subscriptionSubmitted.unsubscribe();
  }
}
